import { useCallback } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import useSWR, { SWRConfiguration } from "swr"

import { clusterAPI } from "@/utils/api"

export function useClusterSWR<T>(key: Parameters<typeof useSWR>[0], config: SWRConfiguration = {}, method = "GET") {
  const { getAccessTokenSilently } = useAuth0()
  const fetcher = useCallback(
    async (route: string) => {
      const token = await getAccessTokenSilently()
      return clusterAPI
        .setToken(token)
        .modify<T>(method, route)
        .then(({ data }) => data)
    },
    [getAccessTokenSilently, method]
  )
  return useSWR<T>(key, { ...config, fetcher })
}

export default useClusterSWR
